module.exports = __webpack_public_path__ + "img/img3.00651c10.png";